import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FormButton from "../FormParts/FormButton";
import { getRequest } from "../Services/ContrectBackendAPI";
import UserProfile from "../Context/UserProfile";
import "./DetailApplication.css";
import RemarkListDisplay from "../CommonPages/RemarkListDisplay";
import OtherData from "../Context/OtherData";
import Payment from "./Payment";
import PaymentList from "./PaymentList";
import AgreementNegotiation from "../CommonPages/AgreementNegotiation";
import ReportDisplay from "../CommonPages/ReportDisplay";

const DetailCloseContract = ({ setUserName,setPageTitle }) => {
	const [remarkList, setRemarkList] = useState();
	const [agReportData, setAgReportData] = useState([]);
	const [agreementObj, setAgreementObj] = useState();
	const [items, setItems] = useState();
	const [terms, setTerms] = useState();
	const [agreementRemarks, setAgreementRemarks] = useState();
	const [totalRaisedInvoice,setTotalRaisedInvoice]=useState(0)
	const [invoices, setInvoices] = useState();
	const [paymentData, setPaymentData] = useState();
	const [payList, setPayList] = useState();
	const [remarkType, setRemarkType] = useState();
	const [remarkData, setRemarkData] = useState();
	const [payListDisplay, setPayListDisplay] = useState(0);
	const [totalPaid,setTotalPaid]=useState(0);

	const [payRemarks, setPayRemarks] = useState([]);
	const navigate = useNavigate();
	useEffect(() => {


		setUserName(UserProfile.getName());
		setPageTitle("Contract details")
		setPayListDisplay("");
		if (UserProfile.getLoginStatus() === 1) {
			console.log("Arpan1");
			navigate("/Home");
		}
		if (OtherData.getData() !== "" && OtherData.getData().length > 0) {
			var obj = JSON.parse(OtherData.getData());
			console.log(obj);
			loadAgreement(UserProfile.getToken(),obj.id);
			loadItems(UserProfile.getToken(),obj.id);
			loadTerms(UserProfile.getToken(),obj.id);
			loadRemarks(UserProfile.getToken(),obj.id);
			loadInvoices(UserProfile.getToken(),obj.id);
			loadPayments(obj.id);
		}

	}, []);
	const loadAgreement=async (token,id)=>{
		const agreement= await getRequest("api/Business/GetUserAgreementDetail?agreementId="+id,token);
        const agreementRes= await agreement.json();
		 if(agreementRes.status===1)
        {
            setAgreementObj(agreementRes.data);
        }
	};
    const loadRemarks = async (token,id) => {
      const res = await getRequest(
        `api/Business/GetRemarks?parentId=${id}&type=contract`,
        token
      );
      const json = await res.json();
      if (!json.data) throw new Error('Failed to load remarks');
      setAgreementRemarks(json.data);
    };
    const loadItems = async (token,id) => {
        const response = await getRequest(
        `api/Business/GetAgreementItems?agreementid=${id}`,
        token
        );
        const result = await response.json();

        if (!result.data) {
        throw new Error('Failed to load items');
        }

        setItems(result.data);
    };
    const loadTerms = async (token,id) => {
        const res = await getRequest(
        `api/Business/AgreementTermList?agreementId=${id}`,
        token
        );
        const json = await res.json();
        if (!json.data) throw new Error('Failed to load terms');
        setTerms(json.data);
    };

    const loadInvoices = async (token,id) => {
            const response = await getRequest(`api/Business/InvoiceList?ctId=${id}`, token);
            const result = await response.json();
            if (result.data){
                let invoiceList=[];
                // console.log("Invoice list fetch - " + JSON.stringify(result.data));
                let totalAmt=0;
                for(let i=0;i<result.data.length;i++){
                    if(result.data[i].invoiceStatusId===6){
                        totalAmt+=result.data[i].invoiceAmount;
                    }
                    const res = await getRequest(`api/Business/GetTxnNote?invId=${result.data[i].id}`, token);
                    const resJson = await res.json();
                    // console.log("Txn note from invoice- " + JSON.stringify(resJson))
                    invoiceList.push({
                        id: result.data[i].id,
                        invoiceStatusId:result.data[i].invoiceStatusId,
                        status: result.data[i].status,
                        invoiceNote: result.data[i].invoiceNote,
                        invoiceAmount: result.data[i].invoiceAmount,
                        itemList: result.data[i].items,
                        txnNote: resJson.data,
                        raisedOn: result.data[i].raisedOn,
                        invoiceUid: result.data[i].invoiceUid,
                        contractId:result.data[i].contractId,
                        invoiceDiscount:result.data[i].invoiceDiscount,
                        remarks:result.data[i].remarks,
                        attachments:result.data[i].attachments,
                        createdOn:result.data[i].createdOn
                    });
                }
                setInvoices(invoiceList);
                setTotalRaisedInvoice(totalAmt);
            } 

        
    };

    const loadPayments = async (contractId) => {
        const token = UserProfile.getToken();
        if (!token) return;
        const res = await getRequest(
        `api/Business/PayList?notePayId=${contractId}`,
        token
        );
        const json = await res.json();
        if(json.status===1){
            let amtTotal=0;
            let remarkList=[];
            for(let i=0;i<json.data.length;i++){

                amtTotal+=json.data[i].paidAmount;
                let itemList=[];
                for(let j=0;j<json.data[i].remarks.length;j++){

                    itemList.push({
                        id: String(j),
                        itemId: json.data[i].remarks[j].id,
                        type: json.data[i].remarks[j].ownerId.toString() === UserProfile.getUserId() ? 'user' : 'ai',
                        content: json.data[i].remarks[j].remarkText,
                        timestamp: new Date(json.data[i].remarks[j].createdOn),
                        ownerName: json.data[i].remarks[j].ownerName,
                        typeOfItem: 'Remark',
                    });
                }
                let remarkElement =
                {id:Number(json.data[i].id),
                item:itemList};
                remarkList.push(remarkElement);
            }
            setTotalPaid(amtTotal);
            setPayRemarks(remarkList);
        }
        
        if (!json.data) throw new Error('Failed to load payments');
        setPayList(json.data);
    };

	const openTab = (e, id) => {
		e.preventDefault();
		var tabContent = document.getElementsByClassName("tab-content");
		for (var i = 0; i < tabContent.length; i++) {
			tabContent[i].style.display = "none";
			tabContent[i].classList.remove("active");
		}
		var tabButtons = document.getElementsByClassName("tab-button");
		for (var i = 0; i < tabButtons.length; i++) {
			tabButtons[i].classList.remove("active");
		}
		document.getElementById(id).style.display = "block";
		document.getElementById(id).classList.add("active");
		e.currentTarget.classList.add("active");
	}
	const loadPaymentList = (txNotePayId) => {
		getRequest("api/Business/PayList?notePayId=" + txNotePayId, UserProfile.getToken()).then(r => r.json()).then(res => {
			if (res.status === 1)
			{
				console.log(res.data);
				if (agreementObj.sellerId.toString() === UserProfile.getUserId().toString()) {
					setPayListDisplay("Seller");
				} else
				{
					setPayListDisplay("Buyer");
				}
				if (res.data && res.data.length > 0) {

					setPayList(res.data);
				} else {
					setPayList([]);
				}
			}
			
		}).catch(err => console.log(err));
	}
	const generateNote = (id) => {
		getRequest("api/Business/GenerateTxnNote?invId=" + id, UserProfile.getToken()).then(r => r.json()).then(res => {
			if (res.status === 1) {
				var tempInv = {};
				for (var i = 0; i < invoices.length; i++) {
					if (invoices[i].id === id)
					{
						tempInv = invoices[i];
					}
                } 
				OtherData.setData(JSON.stringify({
					Agreement: agreementObj,
					Note: res.data,
					Invoice: tempInv
				}));
				loadInvoices(UserProfile.getToken(),agreementObj.id);
			} else
			{
				console.log("Not able to generate note");
				alert("Not able to generate transaction note.");
			}
			
		}).catch(err => console.log(err));
	}
	const loadReportData = () => {
		getRequest("api/business/ContractDayReport?agId=" + agreementObj.id, UserProfile.getToken()).then(r => r.json()).then(res => {
			if (res.status === 1) {
				var total = 0;
				for (var i = 0; i < items.length; i++) {
					total += items[i].itemQuantity * items[i].buyerRate;
				}
				console.log(total);
				res.data["totalValue"] = total;
				setAgReportData(res.data);
				console.log(res.data);
			} else {
				console.log("Not able to generate note");
			}

		}).catch(err => console.log(err));
	};
	const getPDF = async () => {

		let token= UserProfile.getToken();
		if(!token){
			alert('Error', 'Please login again to download PDF');
			navigate('/Login');
			return;
		}
		const result=await getRequest(`api/Business/GetPDF?contractId=${agreementObj.id}`, token);
		const resJson= await result.json();
		if(resJson.status===1)
		{
			const pdfUrl=resJson.data;
			alert('Success', 'PDF generated successfully. Opening PDF...');
			await openFile(pdfUrl);
		}else{
			alert('Error', 'Failed to generate PDF. '+resJson.message);
		}
    };

	const openFile = async (url) => {

		window.open(url, '_blank', 'noopener,noreferrer');
    };

	return (
		<><div className="main-content" >
			{agreementObj && agreementObj.id > 0 ? <div className="table" style={{ textAlign: "left" }}>
				<RemarkListDisplay remarkLst={remarkList} setRemarkLst={setRemarkList} />
				<ReportDisplay reportData={agReportData} setReportData={setAgReportData}/>
				<Payment reloadMethod={() => loadInvoices(UserProfile.getToken(),agreementObj.id)} data={paymentData} setData={setPaymentData} />
				<PaymentList setDisplayList={setPayListDisplay} displayList={payListDisplay} payLst={payList} setPayLst={setPayList} />
				<AgreementNegotiation
					reloadAction={() => { loadInvoices(UserProfile.getToken(),agreementObj.id); }}
					type={remarkType}
					data={remarkData}
					setData={setRemarkData}
				/>
				<div className="row">
					<div className="col-md-12">
						<div className="row p-1" style={{ textAlign: "center" }}>
							<div className="col-md-1">
									<FormButton name="Back" onClick={(e) => {
										e.preventDefault();
										OtherData.resetData();
										navigate("/Home");
									}} />
								</div>
								<div className="col-md-3">
									<FormButton name="Report" onClick={(e) => {
										e.preventDefault();
										alert("Generate report is under constuction.")
										// loadReportData();
									}} />
								</div>
								<div className="col-md-3">
									<FormButton name="Get PDF" onClick={(e) => {
										e.preventDefault();
										getPDF();
										// loadReportData();
									}} />
								</div>
							</div>
					</div>
				</div>
				<div className="tabs">
					<div className="tab-buttons">
						<button className="tab-button active" onClick={(e) => {
							openTab(e, "Items");
						}}>Invoice</button>
						<button className="tab-button" onClick={(e) => { openTab(e, "Payments"); }}>Payments</button>
						<button className="tab-button" onClick={(e) => { openTab(e, "Taxes"); }}>Contract Info</button>
						<button className="tab-button" onClick={(e) => { openTab(e, "Terms"); }}>Item & Terms</button>
					</div>
					<div id="Items" className="tab-content active">
						{invoices && invoices.length > 0 ? invoices.map(x => <>
							{x.status === "Draft" && agreementObj.sellerId.toString() === UserProfile.getUserId().toString() ? <>
								<div className="invoiceDisplay">

									<div className="row">
										<div className="col-md-12">
											<h4> Invoice detail</h4>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Unique id: </strong>
												{x.invoiceUid}
											</span>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Invoice Amount: </strong>
												{x.invoiceAmount}
											</span>
										</div>
										<div className="col-md-3">
											<span>
												<strong>Invoice Note: </strong>
												{x.invoiceNote}
											</span>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Invoice Status: </strong>
												{x.status}
											</span>
										</div>
										<div className="col-md-3">
											<span>
												<strong>Raised On: </strong>
												{x.raisedOn}
											</span>
										</div>
									</div>
								</div>
							</> : <></>}
							{x.status !== "Draft" ? <>
								<div className="invoiceDisplay">
									<div className="row">
										<div className="col-md-12">
											<h4> Invoice detail</h4>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Invoice Amount: </strong>
												{x.invoiceAmount}
											</span>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Unique id: </strong>
												{x.invoiceUid}
											</span>
										</div>
										<div className="col-md-3">
											<span>
												<strong>Invoice Note: </strong>
												{x.invoiceNote}
											</span>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Invoice Status: </strong>
												{x.status}
											</span>
										</div>
										<div className="col-md-3">
											<span>
												<strong>Raised On: </strong>
												{x.raisedOn}
											</span>
										</div>
										<div className="col-md-12">
											<details>
												<summary>Invoice Item List</summary>
												<div>
													{x.itemList && x.itemList.length > 0 ? <>
														<div className="row tableHeader">
															<div className="col-md-1">Code</div>
															<div className="col-md-2">Title</div>
															<div className="col-md-2">Description</div>
															<div className="col-md-1">Tax</div>
															<div className="col-md-1">Quantity</div>
															<div className="col-md-1">Rate</div>
															<div className="col-md-2">Calculation</div>
															
														</div>
														{x.itemList.map(y => <>

															<div className="row">
																<div className="col-md-1">{y.itemHsnSac}</div>
																<div className="col-md-2">{y.itemTitle}</div>
																<div className="col-md-2">{y.itemDescription}</div>
																<div className="col-md-1">{y.itemTax}</div>
																<div className="col-md-1">{y.itemQuantity}</div>
																<div className="col-md-1">{y.itemRate}</div>
																<div className="col-md-2">
																	{y.itemQuantity * y.itemRate}
																	+{y.itemQuantity * y.itemRate * y.itemTax / 100}=
																	{y.itemQuantity * y.itemRate
																	+y.itemQuantity * y.itemRate * y.itemTax / 100}
																</div>

															</div>
														</>)}
													</> : <>No items in invoice</>}
												</div>
											</details>

										</div>
									</div>
									{x.txnNote && x.txnNote.id ? <>
										{
											x.txnNote.status === "Draft" && agreementObj.buyerId.toString() === UserProfile.getUserId().toString() ? <div className="row">
												<div className="col-md-12">
													<h4> Transaction Note</h4>
												</div>
												<div className="col-md-3">
													<span>
														<strong>Note: </strong>
														{x.txnNote.noteRemark}
													</span>
												</div>
												<div className="col-md-3">
													<span>
														<strong>Status: </strong>
														{x.txnNote.status}
													</span>
												</div>
												<div className="col-md-3">
													<span>
														<strong>Panality: </strong>
														{x.txnNote.panalityPercent}
													</span>
												</div>
												
											</div> :<></>
										}
										{
											x.txnNote.status !== "Draft" ? <div className="row">
													<div className="col-md-12">
														<h4> Transaction Note</h4>
													</div>
													<div className="col-md-3">
														<span>
															<strong>Note: </strong>
															{x.txnNote.noteRemark}
														</span>
													</div>
													<div className="col-md-2">
														<span>
															<strong>Status: </strong>
															{x.txnNote.noteStatus}
														</span>
													</div>
													<div className="col-md-2">
														<span>
															<strong>Panality: </strong>
															{x.txnNote.panalityPercent}
														</span>
												</div>
												<div className="col-md-2">
													<div className="col-md-1">
														<strong className="d-inline d-md-none">Remarks: </strong>
														<span>
															{x.txnNote.communication && x.txnNote.communication.length > 0 ?
																<img src={"/comment2.png"} alt="Comment" className="commentIcon" width={20} height={20}
																	onClick={(e) => {
																		e.preventDefault();
																		setRemarkList(x.txnNote.communication);
																	}}
																/> : <span style={{ fontSize: "70%" }}>No remarks</span>}
															<br />
														</span>
													</div>
												</div>
													<div className="col-md-12">
														<details>
															<summary>Transaction Note Item List</summary>
															<div>
																{x.txnNote.items && x.txnNote.items.length > 0 ? <>
																<div className="row tableHeader">
																	<div className="col-md-1">Code</div>
																	<div className="col-md-2">Title</div>
																	<div className="col-md-2">Description</div>
																	<div className="col-md-1">Buyer/Seller Rate</div>
																	<div className="col-md-1">Defected</div>
																	<div className="col-md-1">Remarks</div>
																	<div className="col-md-2">Action</div>
																	
																	</div>
																	{x.txnNote.items.map(y => <>

																		<div className="row">
																			<div className="col-md-1">{y.invoiceItem.itemHsnSac}</div>
																			<div className="col-md-2">{y.invoiceItem.itemTitle}</div>
																			<div className="col-md-2">{y.itemDescription}</div>
																			<div className="col-md-1">{y.itemRate}/{y.invoiceItem.itemRate}</div>
																			<div className="col-md-1">{y.receivedCount}</div>
																			<div className="col-md-1">
																				<strong className="d-inline d-md-none">Remarks: </strong>
																				<span>
																					{y.communication && y.communication.length > 0 ?
																						<img src={"/comment2.png"} alt="Comment" className="commentIcon" width={20} height={20}
																							onClick={(e) => {
																								e.preventDefault();
																								setRemarkList(y.communication);
																							}}
																						/> : <span style={{ fontSize: "70%" }}>No remarks</span>}
																					<br />
																				</span>
																			</div>

																		</div>
																	</>)}
																</> : <>No items in transaction note</>}
																
															</div>
														</details>

													</div>
											</div> : <></>
										}
										
									</> : <></>}


								</div>
							</> : <></>}
							
						</>) : <>No invoices</>}

					</div>
					<div id="Payments" className="tab-content">
						{payList && payList.length > 0 ? payList.map(x => <>
							<div className="invoiceDisplay">

									<div className="row">
										<div className="col-md-12">
											<h4> Payment detail</h4>
										</div>
										<div className="col-md-2">
											<span>
												<strong>Pay amount: </strong>
												{x.paidAmount} INR
											</span>
										</div>
										<div className="col-md-3">
											<span>
												<strong>Note: </strong>
												{x.paymentNote}
											</span>
										</div>
										<div className="col-md-3">
											<span>
												<strong>Paid on: </strong>
												{x.createdOn}
											</span>
										</div>
									</div>
								</div>
							
						</>) : <>No Payments</>}

					</div>
					<div id="Taxes" className="tab-content">
						<div className="row" style={{ textAlign: "left", paddingBottom: '10px' }}>
							<div className="col-md-6"><strong style={{ color: "#0F172A" }}>Seller</strong>
								<br /><strong>Name: </strong>{agreementObj.sellerName}
								<br /><strong>Phone Number: </strong>{agreementObj.sellerPhoneNumber}

							</div>
							<div className="col-md-6"><strong style={{ color: "#0F172A" }}>Buyer</strong>
								<br /><strong>Name: </strong>{agreementObj.buyerName}
								<br /><strong>Phone Number: </strong>{agreementObj.buyerPhoneNumber}
							</div>

						</div>
						<div className="row" style={{ textAlign: "left", paddingBottom: '10px' }}>

							<div className="col-md-6"><strong style={{ color: "#0F172A" }}>Other details</strong>
								<br /><strong>Contract name: </strong>{agreementObj.contractName} 
								<br /><strong>Description: </strong>{agreementObj.contractDescription}
								<br /><strong>Unique Id: </strong>{agreementObj.contractUid}
								<br /><strong>Security deposit: </strong>{agreementObj.agreementSecurityAmount}
								<br /><strong>Started on: </strong>{agreementObj.agreementStartDate}
								<br /><strong>Ends on: </strong>{agreementObj.agreementEndDate}
							</div>
							<div className="col-md-6">
								<br /><strong>Contract duration: </strong>{agreementObj.agreementCompletionInDays} days
								<br /><strong>LD percent: </strong>{agreementObj.agreementLdPercent}%
								<br /><strong>LD Days: </strong>{agreementObj.agreementLdAppliedAfterDays} days
								<br /><strong>Advance: </strong>{agreementObj.agreementAdvancePercent}%
								<br /><strong>Status: </strong>{agreementObj.status}
								<br /><strong>Auto generate invoice: </strong>{agreementObj.autoGenInvoice?"Yes":"No"}
							</div>

						</div>
					</div>

					<div id="Terms" className="tab-content">
						<div className="row">
							<div className="col-md-12 pt-2 ">
								<div className="row">
									<div className="col-md-12 p-0">
										<h4 className="headingStyle">Invoice Items</h4>
									</div>
								</div>
								<div className="d-none d-md-block">
									<div className="row tableHeader ">
										<div className="col-md-1 ">
											Code
										</div>
										<div className="col-md-2 ">
											Title
										</div>
										<div className="col-md-3 ">
											Description
										</div>
										<div className="col-md-1 ">
											Quantity
										</div>
										<div className="col-md-2 ">
											Rate
										</div>
										<div className="col-md-1 ">
											Tax
										</div>
										<div className="col-md-1 ">
											Completion
										</div>

									</div>
								</div>

								{items && items.length > 0 ? items.map((x, ind) => <div className="row p-1 tablebox">
									<div className="col-md-1 d-flex align-items-center">
										<span>
											<strong className="d-inline d-md-none">Code: </strong>
											{x.itemHsnSac}</span>

									</div>
									<div className="col-md-2 d-flex align-items-center">
										<span>
											<strong className="d-inline d-md-none">Title: </strong>
											{x.itemTitle}
										</span>
									</div>
									<div className="col-md-3 d-flex align-items-center">
										<span>
											<strong className="d-inline d-md-none">Description: </strong>
											{x.itemDescription}</span>
									</div>
									<div className="col-md-1 d-flex align-items-center">
										<span>
											<strong className="d-inline d-md-none">Quantity: </strong>
											{x.itemQuantity}</span>
									</div>
									<div className="col-md-2 d-flex align-items-center" style={{ fontSize: "70%" }}>
										<span id={"displayRate" + x.id}>
											<span>{x.itemRate} {agreementObj.currency}/{x.unitName} </span>
										</span>
									</div>
									<div className="col-md-1 d-flex align-items-center">
										<span id={"displayTax" + x.id}>
											{x.itemTax} %
										</span>
									</div>
									<div className="col-md-1 d-flex align-items-center">
										<span id={"displayCompletion" + x.id} style={{ fontSize: "70%" }}>
											{x.itemDeliveredInDays} days 
										</span>
									</div>
								</div>) : <div className="row"> No Items in Purchase Agreement</div>}
							</div>

							<div className="col-md-12 pt-2 ">
								<div className="row">
									<div className="col-md-12 p-0">
										<h4 className="headingStyle">Terms</h4>
									</div>
								</div>
								<div className="row">
									<div className="col-md-1 tableHeader">S. No.</div>
									<div className="col-md-2 tableHeader">Title</div>
									<div className="col-md-4 tableHeader">Terms And Conditions</div>
									<div className="col-md-3 tableHeader">Attachment</div>
								</div>

								{terms && terms.length > 0 ? terms.map((x, ind) => <div className="row p-1 tablebox">
									<div className="col-md-1">
										<strong className="d-inline d-md-none">S.No.: </strong>
										{ind + 1} </div>
									<div className="col-md-2">
										<strong className="d-inline d-md-none">Title: </strong>
										{x.termTitle} </div>
									<div className="col-md-4">
										<strong className="d-inline d-md-none">Terms And Conditions: </strong>
										{x.termTxt}
									</div>
									<div className="col-md-3">
										<span>
											<strong className="d-inline d-md-none">Attachments: </strong>
											{x.attachments ? x.attachments.map((i) => < div className="col-md-12" style={{
												marginBottom: "2px"
											}}>
												<a href={i.link} target={"new"}>
													<img src={i.link} width={50} height={50} />
												</a>
											</div>) : <span style={{ fontsize: "70%" }}>No Attachments</span>}
										</span></div>
								</div>) : <div className="row"> No Items in Purchase Agreement</div>}

							</div>
						</div>
					</div>
				</div>
				


			</div> : <div> Not able to display order details</div>}
		</div>
			
			
		</>
	);
};
export default DetailCloseContract;
